import { useTranslation } from 'react-i18next'

//Intersection
import { useInView } from 'react-intersection-observer'

//Components
import ManualCard from '../../components/Tourbooks/ManualCard'

//images
import imgCard1 from '../../assets/images/tourbooks/card-1-bg-mb@2x.jpg'
import imgCard2 from '../../assets/images/tourbooks/card-2-bg-mb@2x.jpg'
import imgCard3 from '../../assets/images/tourbooks/card-3-bg-mb@2x.jpg'

const Cards = () => {
    const { t } = useTranslation()

    const [cards, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    })

    return (
        <section className={`incoming-tourbooks__cards animate slide-up ${inView ? 'in-view' : ''}`} ref={cards}>
            <ManualCard
                title={t('tourbooks.cards.card1.title')}
                subtitle={t('tourbooks.cards.card1.subtitle')}
                img={imgCard1}
                href="#"
            />
            <ManualCard
                title={t('tourbooks.cards.card2.title')}
                subtitle={t('tourbooks.cards.card2.subtitle')}
                img={imgCard2}
                href="#"
            />
            <ManualCard
                title={t('tourbooks.cards.card3.title')}
                subtitle={t('tourbooks.cards.card3.subtitle')}
                img={imgCard3}
                href="#"
            />
        </section>
    )
}

export default Cards
